import React from 'react'
import AboutSlide from '../inc/AboutSlide'


function Aboutus() {
  return (
    <div>
        <br/>
        <div className="album py-1">
        
        <div className="container">
            <div className="row">
            <div className="col-md-7 mt-3">
                <div class="card-body">
    <h1 className="card-title mb-2"><b style={{color:"#0D7D0B"}}>About Us</b> <b style={{color:"#48340A"}}>– Lodge Green House</b></h1>
    <p style={{color:"#0B247D"}} className="card-text justifytext">Welcome to Lodge Green House, your comfortable and affordable stay option in the heart of Krishnanagar. Conveniently located at 5, R.N Tagore Road, Sadar Hospital More, we provide a peaceful and homely environment for travelers, families, and business guests.</p>
    <p style={{color:"#0B247D"}} className='justifytext' >Our lodge offers well-maintained AC rooms with modern amenities like Free Wi-Fi, clean attached bathrooms, and comfortable bedding to ensure a relaxing stay. We focus on cleanliness, safety, and friendly service so that every guest feels at home.</p>

    <h5 style={{color:"#48340A"}}>Fresh & Hygienic <b className='blink' >Home-Style Bengali Food</b> Available</h5>
  </div>
                </div>
                <div className="col-md-5 mt-3">
                    <AboutSlide/>

                </div>
                </div>
                </div>
            </div>

    </div>
  )
}

export default Aboutus